import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'

const CardBody3 = (props) => {
  return (
    <Panel.Body className={props.className}>
      {props.children}
    </Panel.Body>
  )
}

CardBody3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

CardBody3.defaultProps = {
  className: ''
}

export default CardBody3
